import React, { useEffect, useState } from 'react';

const StateDropDown = (props) => {
    const {value, onChange } = props;

    const [state, setState] = useState(value);
    const onValChange = (e) => {
        setState(e.target.value);
        if(onChange)onChange(e.target.value);
    }

    useEffect(() => {
        if(value!==state)
        setState(value);
    }, [value]);

    return (

        <select name="state" className="input" value={state} onChange={onValChange} >
            <option value="">-- Select State / Union Territory --</option>
            <option value="andhra_pradesh">Andhra Pradesh</option>
            <option value="arunachal_pradesh">Arunachal Pradesh</option>
            <option value="assam">Assam</option>
            <option value="bihar">Bihar</option>
            <option value="chhattisgarh">Chhattisgarh</option>
            <option value="goa">Goa</option>
            <option value="gujarat">Gujarat</option>
            <option value="haryana">Haryana</option>
            <option value="himachal_pradesh">Himachal Pradesh</option>
            <option value="jharkhand">Jharkhand</option>
            <option value="karnataka">Karnataka</option>
            <option value="kerala">Kerala</option>
            <option value="madhya_pradesh">Madhya Pradesh</option>
            <option value="maharashtra">Maharashtra</option>
            <option value="manipur">Manipur</option>
            <option value="meghalaya">Meghalaya</option>
            <option value="mizoram">Mizoram</option>
            <option value="nagaland">Nagaland</option>
            <option value="odisha">Odisha</option>
            <option value="punjab">Punjab</option>
            <option value="rajasthan">Rajasthan</option>
            <option value="sikkim">Sikkim</option>
            <option value="tamil_nadu">Tamil Nadu</option>
            <option value="telangana">Telangana</option>
            <option value="tripura">Tripura</option>
            <option value="uttar_pradesh">Uttar Pradesh</option>
            <option value="uttarakhand">Uttarakhand</option>
            <option value="west_bengal">West Bengal</option>

            <option value="andaman_nicobar_islands">Andaman & Nicobar Islands</option>
            <option value="chandigarh">Chandigarh</option>
            <option value="dadra_nagar_haveli_daman_diu">Dadra & Nagar Haveli and Daman & Diu</option>
            <option value="delhi">Delhi</option>
            <option value="jammu_kashmir">Jammu & Kashmir</option>
            <option value="ladakh">Ladakh</option>
            <option value="lakshadweep">Lakshadweep</option>
            <option value="puducherry">Puducherry</option>
        </select >

    )
}

export default StateDropDown;